import React from 'react';
import PropTypes from 'prop-types';

import { SuiContainer, SuiDropdown, SuiDropdownOption } from '@splashthat/sui';

import Modal from 'common/icons/Modal';
import Panel from 'common/icons/Panel';
import ModalFull from 'common/icons/ModalFull';

import {
    DISPLAY_MODE_STANDARD,
    DISPLAY_MODE_PANEL,
    PANEL_DISPLAY_RIGHT,
    PANEL_DISPLAY_LEFT,
    DISPLAY_MODE_FULL_SCREEN,
} from 'common/entities/form/styleConfiguration/constants';

import CustomElementTypeTabsSelector from '../CustomElementTypeTabsSelector';

import './styles.styl';

const STANDARD_LABEL = 'Standard';
const PANEL_LABEL = 'Panel';
const FULL_SCREEN_LABEL = 'Full Screen';

const PANEL_DISPLAY_PLACEHOLDER = 'Pick panel display';
const PANEL_LEFT = 'Panel Left';
const PANEL_RIGHT = 'Panel Right';

const DISPLAY_MODE_TABS = [
    {
        icon: Modal,
        label: STANDARD_LABEL,
        value: DISPLAY_MODE_STANDARD,
    },
    {
        icon: Panel,
        label: PANEL_LABEL,
        value: DISPLAY_MODE_PANEL,
    },
    {
        icon: ModalFull,
        label: FULL_SCREEN_LABEL,
        value: DISPLAY_MODE_FULL_SCREEN,
    },
];

const isValuePanelSize = (value) => value === DISPLAY_MODE_PANEL;

const baseClassName = 'DisplayModeEditor';

export default class DisplayModeEditor extends React.Component {
    static propTypes = {
        displayMode: PropTypes.oneOf([DISPLAY_MODE_STANDARD, DISPLAY_MODE_PANEL, DISPLAY_MODE_FULL_SCREEN]).isRequired,
        panelDisplay: PropTypes.oneOf([PANEL_DISPLAY_RIGHT, PANEL_DISPLAY_LEFT]).isRequired,
        onChangeDisplayMode: PropTypes.func.isRequired,
        onChangePanelDisplay: PropTypes.func.isRequired,
        qaId: PropTypes.string.isRequired,
    };

    render() {
        const { qaId, displayMode, panelDisplay, onChangePanelDisplay, onChangeDisplayMode } = this.props;

        return (
            <SuiContainer>
                <CustomElementTypeTabsSelector
                    tabs={DISPLAY_MODE_TABS}
                    value={displayMode}
                    onChange={onChangeDisplayMode}
                    qaId={qaId}
                />
                {isValuePanelSize(this.props.displayMode) && (
                    <SuiContainer className={`${baseClassName}__dropdown`} data-qa={`${qaId}--dropdown`}>
                        <SuiDropdown
                            value={panelDisplay}
                            placeholder={PANEL_DISPLAY_PLACEHOLDER}
                            fullWidth
                            onChange={(event, value) => onChangePanelDisplay(value)}
                        >
                            <SuiDropdownOption
                                key={PANEL_DISPLAY_LEFT}
                                value={PANEL_DISPLAY_LEFT}
                                displayValue={PANEL_LEFT}
                            />
                            <SuiDropdownOption
                                key={PANEL_DISPLAY_RIGHT}
                                value={PANEL_DISPLAY_RIGHT}
                                displayValue={PANEL_RIGHT}
                            />
                        </SuiDropdown>
                    </SuiContainer>
                )}
            </SuiContainer>
        );
    }
}
